import { useState } from 'react';

import { UploadInput } from 'components/form-elements/UploadInput';

type Props = {
  label?: string;
  required?: boolean;
  multiple?: boolean;
};

export const Upload = ({ label, required, multiple }: Props) => {
  const [fileNames, setFileNames] = useState<Array<string>>([]);

  const fileNamesStr = fileNames.length ? fileNames.join(', ') : undefined;

  return (
    <UploadInput
      type="file"
      name="files"
      fileName={fileNamesStr}
      required={required}
      multiple={multiple}
      buttonText={label}
      onChange={(e) => {
        const files = e.currentTarget.files;

        if (files?.length) {
          setFileNames([]); // Initalize FX when user decides to choose files again

          for (const file of files) {
            setFileNames((prev) => [...prev, file.name]);
          }
        }
      }}
    />
  );
};
